var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      staticClass: "c-button__dropdown__container__overlay",
      class: {
        "c-button__dropdown__container__overlay__active": _vm.isActiveDropdown,
      },
      on: { click: _vm.hideDropdownContainer },
    }),
    _c(
      "div",
      {
        staticClass: "c-button c-button_with-icon",
        class: { "c-button_responsive": _vm.responsive !== undefined },
      },
      [
        _vm.type !== "dropdown"
          ? _c(
              "div",
              { staticClass: "c-button__wrapper", on: { click: _vm.click } },
              [
                _vm.type === "with-icon"
                  ? _c(
                      "div",
                      { staticClass: "c-button__icon" },
                      [
                        _c("c-icon", {
                          attrs: { icon: _vm.icon, color: _vm.iconColor },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.label
                  ? _c("div", { staticClass: "c-button__label" }, [
                      _vm._v(" " + _vm._s(_vm.label) + " "),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm.type === "dropdown"
          ? _c(
              "div",
              {
                staticClass: "c-button__wrapper",
                class: { "c-button__wrapper__active": _vm.isActiveDropdown },
                on: {
                  click: function ($event) {
                    _vm.isActiveDropdown = !_vm.isActiveDropdown
                  },
                },
              },
              [
                _vm.dropdownWithIcon
                  ? _c(
                      "div",
                      { staticClass: "c-button__icon" },
                      [
                        _c("c-icon", {
                          attrs: {
                            icon: _vm.dropdownIcon,
                            color: _vm.dropdownIconColor,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.label
                  ? _c("div", { staticClass: "c-button__label__left" }, [
                      _vm._v(" " + _vm._s(_vm.label) + " "),
                    ])
                  : _vm._e(),
                _vm.type === "dropdown"
                  ? _c(
                      "div",
                      { staticClass: "c-button__icon__right" },
                      [
                        _c("c-icon", {
                          attrs: { icon: _vm.icon, color: _vm.iconColor },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.type === "dropdown"
                  ? _c(
                      "div",
                      {
                        staticClass: "c-button__dropdown__container",
                        class: {
                          "c-button__dropdown__container__active":
                            _vm.isActiveDropdown,
                          "c-button__dropdown__container__left":
                            _vm.dropdown.position === "left" ||
                            !_vm.dropdown.position,
                          "c-button__dropdown__container__center":
                            _vm.dropdown.position === "center",
                          "c-button__dropdown__container__right":
                            _vm.dropdown.position === "right",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "c-button__dropdown__container__list",
                          },
                          _vm._l(_vm.dropdown.items, function (item) {
                            return _c(
                              "a",
                              {
                                key: item.value,
                                staticClass:
                                  "c-button__dropdown__container__list__item",
                                class: item.class,
                                attrs: {
                                  href: item.link || "javascript:void(0)",
                                  target: item.link && "_blank",
                                },
                                on: {
                                  click: function ($event) {
                                    !item.link && _vm.onItemClick(item)
                                  },
                                },
                              },
                              [
                                item.icon
                                  ? _c("c-icon", {
                                      attrs: {
                                        icon: item.icon,
                                        color: item.iconColor,
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-button__dropdown__container__list__item__label",
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(item.label),
                                      },
                                    }),
                                    item.component
                                      ? [
                                          _c(item.component, {
                                            tag: "component",
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }